// extracted by mini-css-extract-plugin
module.exports = {"manageBox":"index_manageBox_3GYU3","title":"index_title_BzDLk","manageContent":"index_manageContent_EavG4","form":"index_form_3_TRT","buttonGroup":"index_buttonGroup_3Tifl"};